import _Vue from 'vue'
import axios from 'axios'
import VueI18n from 'vue-i18n'
import defaultLanguagesTrad from '@/locale/lang/fr'
import { AloBaseLg } from '@/models/alo/AloBaseLg'
export const defaultLocale = 'fr'

const prod = true // process.env.NODE_ENV === 'production'

_Vue.use(VueI18n)

//Construction d'un plugin pour exposer la fonction de traduction
const VueAloGetTrad = {
  install : function(Vue:typeof _Vue,options?: any){    
    //@ts-ignore
    Vue.$gt = getTradItem
    //@ts-ignore
    Vue.$gct = getTradItemCollection
    Vue.prototype.$gt = getTradItem
    Vue.prototype.$gct = getTradItemCollection
  }
} 
_Vue.use(VueAloGetTrad)


export const locales = [
  {
    code: 'en',
    name: 'English',
    dir: 'ltr'
  },
  {
    code: 'fr',
    name: 'Francais',
    dir: 'ltr'
  }
]

// Create VueI18n instance with options
export const i18n = new VueI18n({
  locale: defaultLocale, // set locale
  fallbackLocale: 'en',
  silentTranslationWarn:prod,
  silentFallbackWarn:prod,
  messages:{
    [defaultLocale]:defaultLanguagesTrad
  }, // set locale messages
})

const loadedLanguages = [defaultLocale] // our default language that is preloaded 

function setI18nLanguage(lang:string) {
  i18n.locale = lang
  axios.defaults.headers.common['Accept-Language'] = lang
  document.querySelector('html')!.setAttribute('lang', lang)
  return lang
}

function getTradItem<T extends AloBaseLg>(item:{lgs:Array<T>}){
  return item.lgs.find(it => it.lg == i18n.locale)  || item.lgs.find(it => it.lg == i18n.fallbackLocale)
}

// passe de [{lg:"fr",propToSelect:["dataFr1","dataFr2,dataFr3]},{lg:"en",propToSelect:["dataEn1","dataEn2,dataEn3]}]
// à [ {lgs:[{lg:"fr",libelle:"dataFr1"},{lg:"en",libelle:"dataEn1"}]} , {lgs:[{lg:"fr",libelle:"dataFr2"},{lg:"en",libelle:"dataEn2"}]}, {lgs:[{lg:"fr",libelle:"dataFr3"},{lg:"en",libelle:"dataEn3"}]} ]
function getTradItemCollection<T extends AloBaseLg>(item:{lgs:Array<T>},valueSelector:(it:T) => Array<string>) { 
  if(!item) return []
  const maxIdx = Math.max(...item.lgs.map(it => valueSelector(it).length || 0))
  return [...Array(maxIdx).keys()].map((it,idx) => {
      return {lgs:item.lgs.map(l => {return {lg:l.lg,libelle:valueSelector(l)[idx] || ''}})}
    }  
  )
}


export function loadLanguageAsync (lang:string) {
  if (i18n.locale !== lang) {
    if (!loadedLanguages.includes(lang)) {
      return import(/* webpackChunkName: "lang-[request]" */ `@/locale/lang/${lang}`).then(msgs => {
        i18n.setLocaleMessage(lang, msgs.default)
        loadedLanguages.push(lang)
        return setI18nLanguage(lang)
      })
    } 
    return Promise.resolve(setI18nLanguage(lang))
  }
  return Promise.resolve(lang)
}